import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { OidcAuthProvider, useOidcAuth } from "./auth/OidcAuthProvider";
import CheckoutProPage from "./pages/CheckoutProPage";
import CheckoutGlobalPage from "./pages/CheckoutGlobalPage";
import CheckoutProSuccessPage from "./pages/CheckoutProSuccessPage";
import CheckoutGlobalSuccessPage from "./pages/CheckoutGlobalSuccessPage";

const GlobalLoading: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto mb-4"></div>
      <p className="text-gray-600">Verificando sessão...</p>
    </div>
  </div>
);

const AppRoutes: React.FC = () => {
  const { isLoading } = useOidcAuth();

  if (isLoading) {
    return <GlobalLoading />;
  }

  return (
    <Routes>
      <Route path="/checkout/pro" element={<CheckoutProPage />} />
      <Route path="/checkout/global" element={<CheckoutGlobalPage />} />
      <Route path="/checkout/pro/success" element={<CheckoutProSuccessPage />} />
      <Route path="/checkout/global/success" element={<CheckoutGlobalSuccessPage />} />
      <Route path="*" element={<Navigate to="/checkout/pro" replace />} />
    </Routes>
  );
};

const App: React.FC = () => (
  <OidcAuthProvider>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </OidcAuthProvider>
);

export default App; 